module.exports = {
	"articleTitle1": "Nate Wood: Sampling the best of Ann Arbor Restaurant Week",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Cafe Felix",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/about-campus",
	"articleSnippet1": "Jan 15, 2014 ... A swanky, 1950s-feeling French bistro, Café Felix is a great place to drop by for a \nquick soup-and-sandwich lunch or leisurely supper. I did the ...",
	"articleSnippet2": "",
	"foodRecommendations": [],
	"articleTitle2": "",
	"address": "204 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.280236,
		"lng": -83.748953
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/cafefelix.json
// module id = 840
// module chunks = 0